// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"d90751d3","204":"ef3960aa","704":"9d666f0e"}[chunkId] + ".js";
};